import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { isEmpty } from 'lodash'

import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import { IMyProjectList, IMyProjectListResponse, IProjectAttrs } from '../types/project'

export const fetchMyProjectList = async (
  projectId: string | undefined,
  instituteCode: string | undefined,
  curriculumId: string,
) => {
  const resp = await axios.get<IMyProjectListResponse>(
    `${window.apiEndpoint}/my/progress/v1/kdt/projects/${projectId}?institute_code=${instituteCode}&institute_curriculum_id=${curriculumId}`,
  )

  return convertCaseList(resp.data, ConvertType.CAMEL) as IMyProjectList
}

export const useMyProjectListQuery = (
  projectId: string | undefined,
  instituteCode: string | undefined,
  curriculumId: string,
) => {
  return useQuery({
    queryKey: ['myProject', projectId, instituteCode, curriculumId],
    queryFn: () => fetchMyProjectList(projectId, instituteCode, curriculumId),
    enabled: !!projectId,
    retry: 0,
  })
}

export const useMyMergedProjectQuery = (
  projectAttrs: any,
  instituteCode: string | undefined,
  curriculumId: string,
) => {
  return useQuery({
    queryKey: ['my-merged-projects', projectAttrs, instituteCode, curriculumId],
    queryFn: async () => {
      const promises = projectAttrs.map(async (item: IProjectAttrs) => {
        const projectData = await fetchMyProjectList(item.id, instituteCode, curriculumId)

        return { ...item, isSubmitted: !isEmpty(projectData?.submittedAt) }
      })

      return Promise.all(promises)
    },
    enabled: !!projectAttrs?.length && !!instituteCode && !!curriculumId,
  })
}
